'use strict';

function CompanyNoticeService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/notices/:noticeId', {}, {
    "update": {
      method: "PUT"
    }
  });
}

angular.module('dokiv')
  .factory('CompanyNoticeService', [
    '$resource',
    'config',
    CompanyNoticeService
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/notices/CompanyNoticeService.js
// module id = 41
// module chunks = 0